import React from "react";
import { FormattedMessage } from "react-intl";
import { EuiLink } from "@elastic/eui";
import AbstractColumnActions from "../../shared/entity/TableColumnAction";

const columns = (actions) => [
    {
        field: "id",
        name: "ID",
        sortable: true,
        render: (item) => (
            <span>
                <EuiLink>{item}</EuiLink>
            </span>
        ),
        width: 70,
    },
    {
        field: "autoGeneratedCode",
        name: "Auto generated code",
        sortable: true,
        render: (item) => (
            <span>
                <EuiLink>{item}</EuiLink>
            </span>
        ),
        width: 70,
    },
    {
        field: "address",
        name: <FormattedMessage id="location.address" />,
        sortable: true,
    },
    {
        field: "cityName",
        name: <FormattedMessage id="location.city" />,
        sortable: false,
    },
    {
        field: "isApproved",
        name: <FormattedMessage id="location.status" />,
        sortable: true,
    },
    {
        field: "organizationName",
        name: <FormattedMessage id="location.organization" />,
        sortable: false,
    },
    {
        field: "createdAt",
        dataType: "date",
        name: <FormattedMessage id="location.created-at" />,
        sortable: true,
    },
    {
        field: "creatorEmail",
        name: <FormattedMessage id="location.creator.email" />,
        sortable: false,
    },
    {
        field: "name",
        name: <FormattedMessage id="location.name" />,
        sortable: true,
    },
    {
        field: "nameEn",
        name: "Name En",
        sortable: true,
        render: (item) => (
            <span>
                <EuiLink>{item}</EuiLink>
            </span>
        ),
        width: 70,
    },
    {
        field: "nameAr",
        name: "NameAr",
        sortable: true,
        render: (item) => (
            <span>
                <EuiLink>{item}</EuiLink>
            </span>
        ),
        width: 70,
    },
    {
        name: "Actions",
        isActionsPopover: true,
        actions: AbstractColumnActions(actions),
    },
];

export default columns;
